
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getQaEvaluationsForArea",
      resolverType: "query",
      routePath: "/getQaEvaluationsForArea",
      httpMethod: "POST",
    });
  